module.exports = __webpack_public_path__ + "img/name.794f0485.png";